import { render, staticRenderFns } from "./MypageCalendar.vue?vue&type=template&id=957cd130&"
import script from "./MypageCalendar.vue?vue&type=script&lang=ts&"
export * from "./MypageCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports